import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useMainLayout } from './hooks/useMainLayout';
import { useDashboardSidebarConfig } from '@/config/sidebar.config';
import { SidebarBrand, SidebarSignOut } from '@/Shared/components/SidebarBrand/SidebarBrand';
import { MainTemplate } from '@/Templates/Main/Main.template';
import { PageLayoutRight } from '@/Templates/Main/PageLayout/PageLayoutRight';

/**
 * Main Layout
 * Wraps authenticated pages with the sidebar and the sticky page header.
 */
const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { entries, activeId } = useDashboardSidebarConfig(location.pathname);
  const { profileMenuOptions } = useMainLayout();

  return (
    <MainTemplate
      sidebarOptions={{
        entries,
        activeId,
        onSelect: item => {
          navigate(item.path);
        },
        header: <SidebarBrand />,
        footer: <SidebarSignOut onSignOut={profileMenuOptions.onLogOut} />,
      }}
    >
      <PageLayoutRight footerText='Group Link One - BFF Apps'>
        <Outlet />
      </PageLayoutRight>
    </MainTemplate>
  );
};

export { MainLayout };
